/* Publish by EComposer at 2026-04-16 17:27:31*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-tg9idcw292f"]=  window.__ectimmers["ecom-tg9idcw292f"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(i.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-tg9idcw292f"]["f0eqtgazx"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify.analytics){i.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),e.cloneNode(!0).click()}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-tg9idcw292f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tg9idcw292f', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nx7dgv8hss8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nx7dgv8hss8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h7hnn1ru3xm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h7hnn1ru3xm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8rl1ch4kesd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8rl1ch4kesd', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-dy30w1rwjl"]=  window.__ectimmers["ecom-dy30w1rwjl"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-dy30w1rwjl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dy30w1rwjl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8zjnkmd0a8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8zjnkmd0a8n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-km1wix2ql3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-km1wix2ql3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p8qqt6r4z4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p8qqt6r4z4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t19wu6aix3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t19wu6aix3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vcnm2bhknu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vcnm2bhknu', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-t1pxre2gbq"]=  window.__ectimmers["ecom-t1pxre2gbq"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=e.querySelector(".ecom-element.ecom-base-image"),o=e.closest(".core__row--columns");s&&(i(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-t1pxre2gbq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t1pxre2gbq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cyc2gnb8eik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cyc2gnb8eik', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l4pqt3rka9k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l4pqt3rka9k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bou2dozd21').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bou2dozd21', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 

document.addEventListener('DOMContentLoaded', () => {
            // --- DATA ---
            const imageUrls = [
                'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/WEBWEBBW-25.webp',
                'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/WEBWEBBW-14.webp',
                'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/WEBWEBBW-21.webp',
                'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/WEBWEBBW-27_1.webp',
                'https://cdn.shopify.com/s/files/1/0756/1025/9722/files/WEBWEBBW-17.webp'
            ];
            let currentImageIndex = 0;

            // --- DOM ELEMENTS ---
            const gallery = document.getElementById('gallery');
            const lightbox = document.getElementById('lightbox');
            const lightboxImg = document.getElementById('lightbox-img');
            const lightboxCaption = document.getElementById('lightbox-caption');
            const closeBtn = document.getElementById('close-lightbox');
            const prevBtn = document.getElementById('prev-lightbox');
            const nextBtn = document.getElementById('next-lightbox');
            const moreCount = document.getElementById('more-count');

            // --- INITIALIZE GALLERY ---
            const visibleImages = 3;
            if (imageUrls.length > visibleImages) {
                moreCount.textContent = `+${imageUrls.length - visibleImages}`;
            }

            // --- FUNCTIONS ---
            const showImage = (index) => {
                currentImageIndex = index;
                lightboxImg.src = imageUrls[currentImageIndex];
                lightboxCaption.textContent = `Image ${currentImageIndex + 1} of ${imageUrls.length}`;
            };

            const openLightbox = (index) => {
                lightbox.classList.remove('hidden');
                lightbox.classList.add('flex');
                showImage(index);
            };

            const closeLightbox = () => {
                lightbox.classList.add('hidden');
                lightbox.classList.remove('flex');
            };

            const showNextImage = () => {
                const nextIndex = (currentImageIndex + 1) % imageUrls.length;
                showImage(nextIndex);
            };

            const showPrevImage = () => {
                const prevIndex = (currentImageIndex - 1 + imageUrls.length) % imageUrls.length;
                showImage(prevIndex);
            };

            // --- EVENT LISTENERS ---
            gallery.addEventListener('click', (e) => {
                const target = e.target.closest('.gallery-item, .absolute');
                if (target) {
                    const index = parseInt(target.querySelector('img, span')?.dataset.index || target.dataset.index);
                    if (!isNaN(index)) {
                        openLightbox(index);
                    }
                }
            });

            closeBtn.addEventListener('click', closeLightbox);
            nextBtn.addEventListener('click', showNextImage);
            prevBtn.addEventListener('click', showPrevImage);

            // Close lightbox on clicking the background
            lightbox.addEventListener('click', (e) => {
                if (e.target === lightbox) {
                    closeLightbox();
                }
            });

            // Keyboard navigation
            document.addEventListener('keydown', (e) => {
                if (!lightbox.classList.contains('hidden')) {
                    if (e.key === 'Escape') {
                        closeLightbox();
                    } else if (e.key === 'ArrowRight') {
                        showNextImage();
                    } else if (e.key === 'ArrowLeft') {
                        showPrevImage();
                    }
                }
            });
        });
        

        // This script calculates the current day in the UK and displays the correct opening hours.
        document.addEventListener('DOMContentLoaded', function() {
            const container = document.getElementById('opening-hours-container');
            
            // HTML snippets for different days
            const monThursHTML = `
                <p class="bullet">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: inline-block; margin-right:6px;">
                        <path d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z" fill="black"/>
                        <path d="M10.502 5H9.00195V11L14.252 14.15L15.002 12.92L10.502 10.25V5Z" fill="black"/>
                    </svg>
                    <strong>Open Today:</strong>&nbsp;9AM-10PM
                </p>`;

            const fridayHTML = `
                <p class="bullet">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: inline-block; margin-right:6px;">
                        <path d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z" fill="black"/>
                        <path d="M10.502 5H9.00195V11L14.252 14.15L15.002 12.92L10.502 10.25V5Z" fill="black"/>
                    </svg>
                    <strong>Open Today:</strong>&nbsp;9AM-9PM
                </p>`;
            
            const weekendHTML = `
                <p class="bullet">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: inline-block; margin-right:6px;">
                        <path d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z" fill="black"/>
                        <path d="M10.502 5H9.00195V11L14.252 14.15L15.002 12.92L10.502 10.25V5Z" fill="black"/>
                    </svg>
                    <strong>Open Today:</strong>&nbsp;9AM-7PM
                </p>`;

            try {
                // Get the current date and time in the 'Europe/London' time zone.
                const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
                const day = now.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6

                if (day >= 1 && day <= 4) {
                    // Monday to Thursday
                    container.innerHTML = monThursHTML;
                } else if (day === 5) {
                    // Friday
                    container.innerHTML = fridayHTML;
                } else if (day === 0 || day === 6) {
                    // Saturday or Sunday
                    container.innerHTML = weekendHTML;
                }
            } catch (error) {
                console.error("Could not determine opening hours:", error);
                // Fallback content in case of an error
                container.innerHTML = "<p>Please contact us for opening hours.</p>";
            }
        });

} catch(error){console.error(error);}